import { useTranslation } from '@gimlite/common'
import { useStoreUIV1 } from '@gimlite/ui-v1'
import IEM from '@gimlite/ui-v1/assets/logo/IEM_small'
import { Main } from '@gimlite/ui-v1/components/main/main.component'
import { observer } from 'mobx-react-lite'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import LogoIEMFinance from './assets/logo/IEM_FINANCE'

const MainUse = observer(() => {
	const { MenuStore, SSOStore } = useStoreUIV1()
	const navigate = useNavigate()
	const { t } = useTranslation()
	const me = SSOStore.user

	useEffect(() => {
		MenuStore.setMenu([
			{
				key: '/',
				position: 'top',
				title: 'MODULE FINANCES',
				items: [
					{
						key: '/sales',
						label: t('sales.title'),
						icon: 'faMoneyBillTransferSolid'
					},
					{
						key: '/collects',
						label: 'Rapports de collectes',
						icon: 'faTicketSolid'
					}
				]
			}
		])
	}, [t])

	return me ? (
		<Main
			handleEvent={{
				selected: key => navigate(key)
			}}
			config={{
				navigation: {
					logo: LogoIEMFinance(),
					mode: 'drop'
				},
				//! Lors d'une refact du router, ce code apparaitra une fois en global (PROBLEM 1)
				//******* START ************/
				header: {
					logo: IEM()
				}
				//******* STOP ************/
			}}
		/>
	) : null
})

export default MainUse
